var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useReducer, useState } from 'react';
import { settingsReducer, initialSettings } from './settings/settingsReducer';
// import useFirebaseAuth from './useFirebaseAuth/useFirebaseAuth';
import usePasscodeAuth from './usePasscodeAuth/usePasscodeAuth';
export const StateContext = createContext(null);
/*
  The 'react-hooks/rules-of-hooks' linting rules prevent React Hooks fron being called
  inside of if() statements. This is because hooks must always be called in the same order
  every time a component is rendered. The 'react-hooks/rules-of-hooks' rule is disabled below
  because the "if (process.env.REACT_APP_SET_AUTH === 'firebase')" statements are evaluated
  at build time (not runtime). If the statement evaluates to false, then the code is not
  included in the bundle that is produced (due to tree-shaking). Thus, in this instance, it
  is ok to call hooks inside if() statements.
*/
export default function AppStateProvider(props) {
    const [error, setError] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [activeSinkId, setActiveSinkId] = useState('default');
    const [settings, dispatchSetting] = useReducer(settingsReducer, Object.assign(initialSettings, props.settings));
    let contextValue = {
        error,
        setError,
        isFetching,
        activeSinkId,
        setActiveSinkId,
        settings,
        dispatchSetting,
    };
    if (process.env.REACT_APP_SET_AUTH === 'firebase') {
        contextValue = Object.assign({}, contextValue);
    }
    else if (process.env.REACT_APP_SET_AUTH === 'passcode') {
        contextValue = Object.assign(Object.assign({}, contextValue), usePasscodeAuth());
    }
    else {
        contextValue = Object.assign(Object.assign({}, contextValue), { getToken: (identity, roomName) => __awaiter(this, void 0, void 0, function* () {
                const headers = new window.Headers();
                const endpoint = process.env.REACT_APP_TOKEN_ENDPOINT || '/token';
                const params = new window.URLSearchParams({ identity, roomName });
                return fetch(`${endpoint}?${params}`, { headers }).then(res => res.text());
            }) });
    }
    const getToken = (name, room) => {
        setIsFetching(true);
        return contextValue
            .getToken(name, room)
            .then(res => {
            setIsFetching(false);
            return res;
        })
            .catch(err => {
            setError(err);
            setIsFetching(false);
            return Promise.reject(err);
        });
    };
    return React.createElement(StateContext.Provider, { value: Object.assign(Object.assign({}, contextValue), { getToken }) }, props.children);
}
export function useAppState() {
    const context = useContext(StateContext);
    if (!context) {
        throw new Error('useAppState must be used within the AppStateProvider');
    }
    return context;
}
//# sourceMappingURL=index.js.map